import * as React from 'react';

export const dialogBodyStyle: React.CSSProperties = {
    paddingBottom: '14px',
    paddingTop: '30px',
    paddingLeft: '30px',
    paddingRight: '30px',
};

export const headerFontStyle: React.CSSProperties = {
    fontSize: '20px',
    fontWeight: 'normal',
    color: '#333',
    marginBottom: '18px',
};

export const dropdownsContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '18px'
};

export const leftDropdownStyle: React.CSSProperties = {
    width: '100%',
    marginRight: '6px'
}
;
export const rightDropdownStyle: React.CSSProperties = {
    width: '100%',
    marginLeft: '6px'
};
